/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed fantasy points breakdown for each race with driver and constructor scoring analysis.`)
};

const es_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desglose detallado de puntos de fantasía por carrera con análisis de puntuación de pilotos y constructores.`)
};

const de_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaillierte Fantasy-Punkteaufschlüsselung je Rennen mit Fahrer- und Konstrukteuranalyse.`)
};

const nl_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedetailleerde fantasy-puntenuitsplitsing per race met analyse van coureurs en constructeurs.`)
};

const fr_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décomposition détaillée des points fantasy par course avec analyse des pilotes et constructeurs.`)
};

const it_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettaglio punti fantasy gara per gara con analisi di piloti e costruttori.`)
};

const pt_br2_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhamento de pontos fantasy corrida a corrida com análise de pilotos e construtores.`)
};

const pt_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhamento de pontos fantasy corrida a corrida com análise de pilotos e construtores.`)
};

const ja_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライバーとコンストラクターのスコア分析を含むレースごとの詳細なファンタジーポイント内訳。`)
};

const zh_f1_home_card_points_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逐场比赛的详细梦幻积分分解，含车手和车队得分分析。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_card_points_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_card_points_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_card_points_desc", locale)
	if (locale === "en") return en_f1_home_card_points_desc(inputs)
	if (locale === "es") return es_f1_home_card_points_desc(inputs)
	if (locale === "de") return de_f1_home_card_points_desc(inputs)
	if (locale === "nl") return nl_f1_home_card_points_desc(inputs)
	if (locale === "fr") return fr_f1_home_card_points_desc(inputs)
	if (locale === "it") return it_f1_home_card_points_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_card_points_desc(inputs)
	if (locale === "pt") return pt_f1_home_card_points_desc(inputs)
	if (locale === "ja") return ja_f1_home_card_points_desc(inputs)
	return zh_f1_home_card_points_desc(inputs)
};